"use client";
import { ReactNode } from "react";
// import styles from "./BackgroundLayout.module.css";
import Image from "next/image";
import { usePathname } from "next/navigation";

interface ContainerType {
  children: ReactNode;
}
function BackgroundLayout({ children }: ContainerType) {
  const pathname = usePathname().includes("/hero-token");
  return (
    <section className="">
      <div className="pt-[7rem] sm:pt-40  bg-hero-slate-dark">
        <div className="absolute inset-0 z-10 h-screen">
          <Image
            width={1912}
            height={912}
            alt=""
            src={
              pathname ? "/imgs/CityBGH2.png" : "/compressed/wallet-top-section.png"
            }
            className="w-full h-full object-cover 3xl:hidden"
            quality={75}
      
          />

          <Image
            width={1912}
            height={912}
            alt=""
            src={
              pathname
                ? "/imgs/CityBGH2.png"
                : "/compressed/wallet-top-section-big.png"
            }
            className={`w-full h-full object-cover wallet_bg_image_3xl `}
            quality={100}
      
          />
        </div>
        <div className="bg-gradient-to-b from-hero-slate-900 to-transparent absolute top-0 w-full h-[450px] z-0"></div>
        <div className="absolute -bottom-20 md:bottom-0 w-full h-[250px] md:h-[450px] bg-gradient-to-t from-hero-slate-dark via-hero-slate-dark/90 to-hero-slate-dark/0 z-10"></div>
        <div className="w-full h-full absolute inset-0 z-0">
          <Image
            height={1798}
            width={1246}
            src="/imgs/back-shadow-2.svg"
            alt="back-shadow-2.svg"
            className="absolute bottom-0 left-1/2 -translate-x-1/2 z-0 opacity-50 hidden sm:block"
            quality={100}
      
          />
        </div>
      </div>
      <div
        className={`absolute  w-full z-[10] ${
          pathname ? "top-0" : "md:pt-10 top-20"
        } h-full`}
      >
        <div className="min-h-[100vh]">{children}</div>
      </div>
    </section>
  );
}

export default BackgroundLayout;
